import { useRef } from "react";
import CountUp, { useCountUp } from "react-countup";

export const StatsSection = () => {
    const techCounterRef = useRef(null);
    const labCounterRef = useRef(null);
    const marketCounterRef = useRef(null);
    const agrCounterRef = useRef(null);

    // Dental Techs
    useCountUp({
        ref: techCounterRef,
        end: 1130006,
        enableScrollSpy: true,
        duration: 2,
        // scrollSpyDelay: 1000,
    });

    // Dental Labs
    useCountUp({
        ref: labCounterRef,
        end: 178602,
        enableScrollSpy: true,
        duration: 2,
        // scrollSpyDelay: 1000,
    });

    // Market Size
    useCountUp({
        ref: marketCounterRef,
        start: 0,
        end: 130.3,
        decimals: 2,
        prefix: "$",
        suffix: "B",
        enableScrollSpy: true,
        duration: 2,
        // scrollSpyDelay: 1000,
    });

    // Annual Growth Rate
    useCountUp({
        ref: agrCounterRef,
        start: 0,
        end: 6.8,
        decimals: 1,
        suffix: "%",
        enableScrollSpy: true,
        duration: 2,
        // scrollSpyDelay: 1000,
    });

    return (
        <div className="container-fluid">
            <div className="container p-5 px-lg-0">
                <div className="row mb-4">
                    <div className="col-lg-5 text-center">
                        <h1 className="m-0" style={{ fontSize: "xxx-large" }}>
                            INDUSTRY
                        </h1>
                        <h1 className="fw-bold home-title-h1">STATS</h1>
                    </div>
                    <div className="col-lg-7 px-md-5">
                        <h6 className="lh-lg">
                            At WinWinGo, we are proud to provide the dental industry's best employment site.
                            <br />
                            With such a large and growing dental market, we are excited to help match skilled dental talent with top-tier dental employers. Here
                            are some of the latest industry stats at a glance:
                        </h6>
                        <p className="text-muted">
                            <small>(Data from the Bureau of Labor and Statistics)</small>
                        </p>
                    </div>
                </div>
                <div className="row m-md-5 m-lg-3 m-lg-0 bg-dark rounded shadow-lg">
                    <div className="col-lg-5 image-section-implant rounded shadow"></div>
                    <div className="col-lg-7 p-5 text-center">
                        <div className="row mb-lg-5 text-white">
                            <div className="col mb-5">
                                <h1 className="stats-h1" ref={techCounterRef}>
                                    <CountUp start={0} end={1130006} />
                                </h1>
                                <h2>Dental Talent</h2>
                            </div>
                            <div className="col mb-5">
                                <h1 className="stats-h1" ref={labCounterRef}>
                                    <CountUp start={0} end={178602} />
                                </h1>
                                <h2>Dental Employers</h2>
                            </div>
                        </div>
                        <div className="row text-white">
                            <div className="d-lg-none d-block col-lg-1"></div>
                            <div className="col mb-5">
                                <h1 className="stats-h1" ref={marketCounterRef}>
                                    $<CountUp start={0} end={130.3} />
                                </h1>
                                <h2>Market Size (2022)</h2>
                            </div>
                            <div className="col">
                                <h1 className="stats-h1" ref={agrCounterRef}>
                                    <CountUp start={0} end={6.8} />
                                </h1>
                                <h3>Annual Growth Rate (CAGR)</h3>
                            </div>
                        </div>
                        <div className="row text-white mt-4">
                            <div className="col">
                                <p>
                                    The U.S. dental market is projected to reach $216.33 billion by 2030, with several factors driving this growth: rising
                                    demand for cosmetic and aesthetic dental procedures, increased awareness of oral health, and ongoing digital transformation
                                    within the industry.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
